// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1SMUW","amount":"Amount_amount__1ev8M","tip":"Amount_tip__1Bwqf","tipHeader":"Amount_tipHeader__3lvlL","tipsWrap":"Amount_tipsWrap__m_RNk"};